import axios from 'axios';

const TOKEN = '466atbWfEX7cd3slh5xlSZKto-c6yqGL';
const BASE_URL = 'https://iengine.godan.info/Items';

export class DataService {
  static getErrorMessage(error) {
    if (error.response?.data?.errors && Array.isArray(error.response.data.errors)) {
      return error.response.data.errors.map((err) => err.message).join(', ');
    }

    if (error.response?.data?.message) {
      return error.response.data.message;
    }

    if (error.message) {
      return error.message;
    }

    return 'An unknown error occurred';
  }

  static getErrorDetails(error) {
    return {
      data: null,
      status: error.response?.status || 500,
      error: this.getErrorMessage(error),
      errors: error.response?.data?.errors || [],
      extensions: error.response?.data?.errors?.[0]?.extensions || {},
    };
  }

  static async get(endpoint) {
    try {
      const response = await axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      console.log(response);
      return {
        data: response.data.data || response.data,
        status: response.status,
      };
    } catch (error) {
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);

      return {
        data: null,
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
      };
    }
  }

  static async post(endpoint, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
        data,
      });

      return {
        data: response.data.data || response.data,
        status: response.status,
        message: 'Operation successful',
      };
    } catch (error) {
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);

      return {
        data: null,
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
      };
    }
  }

  static async put(endpoint, data) {
    try {
      const response = await axios({
        method: 'PUT',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
        data,
      });

      return {
        data: response.data.data || response.data,
        status: response.status,
        message: 'Operation successful',
      };
    } catch (error) {
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);

      return {
        data: null,
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
      };
    }
  }

  static async patch(endpoint, data) {
    try {
      const response = await axios({
        method: 'PATCH',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
        data,
      });
      return {
        data: response.data.data || response.data,
        status: response.status,
        message: 'Operation successful',
      };
    } catch (error) {
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);
      return {
        data: null,
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
      };
    }
  }

  static async delete(endpoint) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${BASE_URL}${endpoint}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      return {
        data: response.status === 204 ? null : response.data,
        status: response.status,
        message: 'Operation successful',
      };
    } catch (error) {
      console.error('Full error:', error);
      console.error('Response data:', error.response?.data);
      console.error('Response status:', error.response?.status);

      return {
        data: null,
        status: error.response?.status || 500,
        error: error.response?.data?.message || error.message,
      };
    }
  }
}
